<template>
  <el-container>
    <el-aside width="216px">
      <SideBarCmp :isToggle="isToggleSideBar" :data="data" />
    </el-aside>
    <el-container>
      <el-header style="height: 85px">
        <HeaderCmp @toggleSideBar="toggleSideBar" />
      </el-header>
      <el-main class="elMain">
        <!-- <answer
            v-show="display"
            @changeStatus="changeStatus"
            class="answer"
            @onClose="onClose"
          ></answer> -->
          <!-- v-show="!display" -->
        <router-view ></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<style></style>
<script>
// import answer from "../components/Answer.vue";
import SideBarCmp from "./common/SideBarCmp.vue";
import HeaderCmp from "./common/HeaderCmp.vue";
import axiosUtil from "../utils/AxiosUtils.js";
export default {
  data: function () {
    return {
      /* clientH: 0,//动态屏幕可见区域高*/
      isToggleSideBar: false, //侧边栏是否切换成小的
      data: {},
      timer: null,
      timer1: null,
      display: false,
    };
  },
  props: ["clientH"],
  components: {
    SideBarCmp,
    HeaderCmp,
    // answer,
  },
  computed: {
    contentH: function () {
      return this.clientH - 86; //路由内容部分高度
    },
  },
  created: function () {
    if (JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId == "1100000020") {
      this.getmessage();
      this.timing();
    }
  },
  mounted: function () {
    this.data = JSON.parse(sessionStorage.getItem("loginInfo"));
    window.localStorage.setItem(
      "docIdcardA",
      JSON.stringify({
        url: this.data.docIdcardUrlA,
        attId: this.data.docIdcardUrlAAttaId,
      })
    ); //储存用户信息
    window.localStorage.setItem(
      "docIdcardB",
      JSON.stringify({
        url: this.data.docIdcardUrlB,
        attId: this.data.docIdcardUrlBAttaId,
      })
    ); //储存用户信息
  },
  methods: {
    handleClose(done) {
      this.display = false;
    },
    onClose(e) {
      this.display = false;
    },
    changeStatus(e) {
      this.display = true;
      console.log(this.display)
    },
    timing() {
      var _this = this;
      _this.timer = window.setInterval(function () {
        _this.getmessage();
      }, 60000);
    },
    getmessage() {
      let _this = this;
      let options = {
        service: "smarthos.online.outpatient.audit.notice",
        hosId: "1100000020",
        docMobile: JSON.parse(sessionStorage.getItem("loginInfo")).docPrivate.docMobile,
      };
      axiosUtil(
        options,
        function (data) {
          try {
            if (data.code == "0") {
              for (let i in data.list) {
                _this.open2(data.list[i]);
              }
            }
          } catch (e) {}
          clearInterval(_this.timer);
          _this.timing();
        },
        function () {}
      );
    },
    open2(str) {
      this.timer1 = window.setTimeout(() => {
        this.$notify({
          title: "视频复诊预约审核通知",
          message: str,
          type: "info",
          position: "bottom-right",
          duration: 15000,
          customClass: "tips",
        });
      }, 0);
    },
    toggleSideBar: function () {
      //监听更改侧边栏宽度按钮
      this.isToggleSideBar = !this.isToggleSideBar;
    },
  },
};
</script>
<style>
.el-main {
  background-color: #f5f5f5;
}
.tips {
  text-align: left;
}
.el-notification__content {
  text-align: left;
}
.el-notification {
  width: 400px;
}
.elMain{
  position: relative;
}
.answer {
  position: absolute;
  z-index: 999;
  left: 50px;
  top: 50px;
}
</style>
